import { API as e, Resource as t } from "@coveo/platform-client";
//#region src/resources/commerce/RuleCount.ts
var n = class n extends t {
	static {
		this.baseUrl = `/rest/organizations/${e.orgPlaceholder}/commerce/private/rule-count`;
	}
	get(e) {
		return this.api.get(this.buildPath(`${n.baseUrl}`, { trackingIds: e }));
	}
};
//#endregion
export { n as RuleCount };

//# sourceMappingURL=RuleCount.js.map